<template>
	<div class="bookinbar_wrap" id="vue_bookingbar" v-bind:class="{focus_inside: hasAttention, loading: currentlyLoading}" :data-error="errorClasses.join(' ')" v-click-outside="looseAttention">
		<input type="hidden" name="hiddenFields" value="false">
		<input type="hidden" name="redirectToInfoPage" v-model="hotelRedirects">
		<Destination ref="destination" @opened="getAttention" @selectDestination="fireOnMobile" @error="showError" @focus="closeDropDowns" @next="goToDates" />

		<Dates ref="dates" @opened="getAttention" @error="showError" @focus="closeDropDowns" />

		<GuestRooms ref="guestrooms" @opened="getAttention" @focus="closeDropDowns" />

		<RateCode ref="ratecode" @opened="getAttention" @focus="closeDropDowns" />

		<button class="button" type="submit" :disabled="isDirty ? null : 'disabled'" :aria-disabled="isDirty ? null : 'disabled'" :onclick="`citizenm.track('click', {category: 'button', action: 'click', label: '${this.$store.state.language.submit}'})`">{{ this.$store.state.language.submit }}</button>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

import Destination from './components/Destination'
import GuestRooms from './components/GuestRooms'
import RateCode from './components/RateCode'
import Dates from './components/Dates'
import moment from 'moment/src/moment'


export default {
	name: 'Bookingbar',
	components: {
		Destination,
		GuestRooms,
		RateCode,
		Dates
	},
	data: function(){
		return {
			hasAttention: false,
			errorClasses: [],
			hotelRedirects: false,
		}
	},
	created() {
		const v = this;
		window.experiments['hotelRedirects'] = function(){
			v.hotelRedirects = true;

			const buttons = document.querySelectorAll('a.button.replace-hotelRedirectsOnButtons');
			for (let i = 0; i < buttons.length; i++) {
				const button = buttons[i];
				const regex = /(\/[a-zA-Z1-9-_]*)\?/g;
				button.href = button.href.replace(regex, '?');
				button.classList.remove('replace-hotelRedirectsOnButtons');
			}

			// buttons on multiavailability page
			window.experiments['hotelRedirectsOnButtons'] = function(button) {
				if(!button) return false;
				const regex = /(\/[a-zA-Z1-9-_]*)\?/g;
				button.href = button.href.replace(regex, '?');
				button.classList.remove('replace-hotelRedirectsOnButtons');
			}

		}
	},
	mounted() {
		let initData = false

		// set inital dates?!
		if(this.$store.state.arrival && this.$store.state.departure) {
			initData = true
			const arrival = this.$store.state.arrival ? moment(this.$store.state.arrival).format(this.$store.state.dateFormat) : moment().format(this.$store.state.dateFormat)
			const departure = this.$store.state.departure ? moment(this.$store.state.departure).format(this.$store.state.dateFormat) : moment().add(1, 'day').format(this.$store.state.dateFormat)

			this.$store.commit('setArrival', arrival)
			this.$store.commit('setDeparture', departure)
		} else {
			this.$store.dispatch('traveldates', {})
		}

		// initial rate and/or code
		if(this.$store.state.rate_code) {
			initData = true
			const newRate = this.$store.state.rates.filter(rate => rate.code == this.$store.state.rate_code)
			this.$store.commit('setRate', newRate.shift())
		}
		if(this.$store.state.promo_code) {
			initData = true
			this.$store.commit('setPromo', this.$store.state.promo_code)
		}

		// set initial destination
		if(this.$store.state.where) {
			initData = true
			this.$store.dispatch('selectDestination', this.$store.state.where)

			const selectedDestination = [... this.$store.state.destinations].concat(this.$store.state.hotels).filter(dest => dest.id == parseInt(this.$store.state.where))

			// reset availability
			this.$store.commit('setAvailability', {})
			if(selectedDestination.length) {
				this.$store.commit('setDestination', { destination: selectedDestination.shift() })
			}
		}

		if(initData) {
			this.$store.dispatch('loadAvailability')
		}

		this.$store.subscribe((mutation) => this.validateUserInput(mutation))
	},
	computed: {
		currentlyLoading: function () {
			return this.$store.state.currentlyLoading
		},
		errorShowTime: function () {
			return this.$store.state.errorShowTime
		},
		isDirty: function(){
			return this.$store.state.isDirty
		},
	},
	methods: {
		getAttention() {
			this.hasAttention = true
			this.$store.commit('setDirty')
			document.getElementById('vue_bookingbar').parentElement.parentElement.classList.add('focus_inside')
		},
		looseAttention() {
			this.hasAttention = false
			document.getElementById('vue_bookingbar').parentElement.parentElement.classList.remove('focus_inside')
		},
		fireOnMobile() {
			if(window.innerWidth < this.$store.state.mobileBreakpoint) {
				document.getElementById('vue_bookingbar').parentElement.submit()
			}
		},
		showError(error) {
			const that = this
			this.errorClasses.push(error)

			setTimeout(function(){
				const index = that.errorClasses.indexOf(error);
				if (index > -1) {
					that.errorClasses.splice(index, 1);
				}
			}, this.errorShowTime)
		},

		closeDropDowns() {
			// close the other dropdowns
			this.$refs.destination.hideDestinationDropdown()
			this.$refs.dates.closePicker()
			this.$refs.guestrooms.hideDropdown()
			this.$refs.ratecode.hideDropdown()
		},

		validateUserInput(mutation) {

			let filteredDestinations, filteredHotels, filteredRates;


			switch(mutation.type) {
				case 'updateDestinations':
				case 'updateHotels':
					if(this.$store.state.destination) {
						filteredDestinations = this.$store.state.destinations.filter(r => r.id == this.$store.state.destination.id)
						filteredHotels = this.$store.state.hotels.filter(r => r.id == this.$store.state.destination.id)
						if (!filteredHotels.length && !filteredDestinations.length) {
							this.$store.commit('setDestination', { destination: null })
							this.showError('destination_destination_notavailable')
						}
					}
					break
				case 'updateRates':
					if(this.$store.state.rate) {
						filteredRates = this.$store.state.rates.filter(r => r.code == this.$store.state.rate.code)
						if (!filteredRates.length) {
							this.$store.dispatch('clearRate')
							this.showError('rate_notavailable')
						}
					}
					break
				default:
					return
			}
		},

		goToDates(){
			document.getElementById('dates').focus();
		},
	},

	// do not forget this section
	directives: {
		ClickOutside
	}
}
</script>
<style lang="scss">

</style>

TODO: calendar vs. taborder


TODO: loading state for changing fieldsets
TODO: Ajax calendar call
TODO: prices in datepicker
